// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"425":"7fd5ecb5","465":"795421af","625":"ae04887c","722":"97d15cc0","823":"74e89425"}[chunkId] + ".chunk.js";
};